import { render, staticRenderFns } from "./farmBaseInfo.vue?vue&type=template&id=03df9aff&scoped=true"
import script from "./farmBaseInfo.vue?vue&type=script&lang=js"
export * from "./farmBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./farmBaseInfo.vue?vue&type=style&index=0&id=03df9aff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03df9aff",
  null
  
)

export default component.exports